import moment from "moment";
import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DropdownComponent from "../../../containers/Dropdown";
import {
  ENGLISH,
  FRENCH,
  PHONE_PLACEHOLDER,
  PREFERREDLANGUAGEDRPDATA,
  EMAIL_PLACEHOLDER,
  PREFERREDLANGUAGEDRPDATA_FRENCH,
  POSTAL_CODE_PLACEHOLDER,
} from "../../../App.config";
import { date, formatDate } from "../../../utilities/utils";
import DisplayEmployeeBlock from "../../Std/DisplayEmployeeBlock";
import ToggleComponent from "../../../containers/Common/ToggleComponent";
import heart from "../../../images/heart.svg";
import add from "../../../images/add.svg";
import AlertError from "../../../containers/Common/AlertError";
import backArrow from "../../../images/back-arrow.svg";
import CustomDatePicker from "../../../containers/Common/CustomDatePicker";

const EmployeeDetails = ({
  onDateChange,
  state,
  handleChanges,
  handleWeekShift,
  onDropDownChange,
  props,
  onSubmit,
  previousStep,
  isFormValid,
  onAddJob,
  onAddManager,
}) => {
  // Set ers url to initial state
  // useEffect(() => {
  //   props.resetErsApplicationUrl();
  // }, []);

  const decidePreferredLngDrp = () => {
    let defaultPreferLang = PREFERREDLANGUAGEDRPDATA;
    if (props.i18nReducerLang === "en-US") {
      defaultPreferLang = PREFERREDLANGUAGEDRPDATA;
    } else {
      defaultPreferLang = PREFERREDLANGUAGEDRPDATA_FRENCH;
    }

    return defaultPreferLang;
  };

  return (
    <>
      {/* {!isFormValid && <AlertError message={ALERT_ERROR_MESSAGE} />} */}
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <img
                tabIndex="-1"
                className="btn btn-back"
                onClick={previousStep}
                src={backArrow}
                alt="back-arrow"
              />
              <div className="p-img">
                <img src={heart} alt="" />
              </div>
              <h2>
                <span>
                  {props.context.t("STD-Employer-Statement.form.heading2.text")}
                </span>
                {/* <legend>
                  {props.context.t(
                    "STD-Employer-Statement.form.subheading.text"
                  )}
                  <em> {props.context.t("STD-Hamburger.text")} </em>
                </legend> */}
              </h2>
            </div>
            <div className="panel-content">
              <DisplayEmployeeBlock context={props.context} state={state} />
              <div className="Custom-form">
                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading3.text"
                    )}
                  </span>
                </h2>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Address"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="street"
                        value={state.street.value}
                        ref={state.street.ref}
                        onChange={handleChanges}
                        readOnly={!state.street.isEditable}
                      />
                      {state.street?.error && (
                        <span className="error">{state.street.error}</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Country"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <div className="Custom-select">
                        {props.country && (
                          <DropdownComponent
                            name="country"
                            id="country"
                            options={props.country}
                            isMultiSelect={false}
                            option_key="countryId"
                            option_display="countryName"
                            onChange={onDropDownChange}
                            values={state.country.value}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            ref={state.country.ref}
                          />
                        )}
                        {state.country?.error && (
                          <span className="error">{state.country.error}</span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Province"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      {props.state && (
                        <DropdownComponent
                          name="state"
                          id="state"
                          options={props.state}
                          isMultiSelect={false}
                          option_key="provinceId"
                          option_display="province"
                          onChange={(e) => {
                            if (state.state.isEditable) {
                              onDropDownChange(e);
                            }
                          }}
                          values={state.state.value}
                          ref={state.state.ref}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          isSearchOption={true}
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        />
                      )}
                      {state.state?.error && (
                        <span className="error">{state.state.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.City"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      {/* <div className="Custom-select">
                        {props.city && (
                          <DropdownComponent
                            name="city"
                            options={props.city}
                            isMultiSelect={false}
                            option_key="cityId"
                            option_display="cityName"
                            onChange={onDropDownChange}
                            values={state.city.value}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                          />
                        )}
                      </div> */}
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="city"
                        value={state.city.value}
                        ref={state.city.ref}
                        onChange={handleChanges}
                        readOnly={!state.city.isEditable}
                      />
                      {state.city?.error && (
                        <span className="error">{state.city.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-2">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Postal"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={POSTAL_CODE_PLACEHOLDER}
                        name="postalCode"
                        value={state.postalCode.value}
                        ref={state.postalCode.ref}
                        onChange={handleChanges}
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Space is not allowed"
                        readOnly={!state.postalCode.isEditable}
                      />
                      {state.postalCode?.error && (
                        <span className="error">{state.postalCode.error}</span>
                      )}
                    </div>
                  </div>
                </div>

                {/* <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">Job</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.context.t("STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere")}
                        name="jobTitle"
                        value={state.jobTitle.value}
                        onChange={handleChanges}
                      />
                    </div>
                  </div> */}
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-5">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employer-Details.label.text.Phone"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={PHONE_PLACEHOLDER}
                        maxLength="14"
                        name="phone"
                        value={state.phone.value}
                        ref={state.phone.ref}
                        onChange={handleChanges}
                        readOnly={!state.phone.isEditable}
                      />
                      {state.phone?.error && (
                        <span className="error">{state.phone.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employer-Details.label.text.Alternate-Phone"
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={PHONE_PLACEHOLDER}
                        maxLength="14"
                        name="alternativePhone"
                        value={state.alternativePhone.value}
                        ref={state.alternativePhone.ref}
                        onChange={handleChanges}
                        readOnly={!state.alternativePhone.isEditable}
                      />
                      {state.alternativePhone?.error && (
                        <span className="error">
                          {state.alternativePhone.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">&nbsp;</label>
                      <ul>
                        <li className="Radio-box">
                          <div className="check-col">
                            <input
                              type="radio"
                              id="By-Work"
                              name="alternativePhoneType"
                              value="Work"
                              checked={
                                state.alternativePhoneType.value === "Work"
                              }
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-Work">
                              {props.context.t(
                                "STD-Employer-Statement.form.Employee-Details.label.text.Alternative-#.option-Work"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              id="By-Mobile"
                              name="alternativePhoneType"
                              value="Mobile"
                              checked={
                                state.alternativePhoneType.value === "Mobile"
                              }
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-Mobile">
                              {props.context.t(
                                "STD-Employer-Statement.form.Employee-Details.label.text.Alternative-#.option-Mobile"
                              )}
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="row">
                      <div className="col-6">
                        {state.isOtherHasSelected.value ? (
                          <div>
                            <div className="form-group">
                              <label htmlFor="">&nbsp;</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder={props.context.t(
                                  "STD-Employer-Statement.form.dropdown.PlaceHolder.Common.IfOtherSpecifyHere"
                                )}
                                name="other"
                                value={state.other.value}
                                onChange={handleChanges}
                              />
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-5">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Email"
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={EMAIL_PLACEHOLDER}
                        name="employeeEmail"
                        value={state.employeeEmail.value}
                        ref={state.employeeEmail.ref}
                        onChange={handleChanges}
                        readOnly={!state.employeeEmail.isEditable}
                      />
                      {state.employeeEmail?.error && (
                        <span className="error">
                          {state.employeeEmail.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">&nbsp;</label>
                      <li className="Radio-box">
                        <div className="check-col">
                          <input
                            type="radio"
                            id="By-Work-Email"
                            name="employeeEmailType"
                            value="Work"
                            checked={state.employeeEmailType.value === "Work"}
                            onChange={handleChanges}
                          />
                          <label htmlFor="By-Work-Email">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.option-Work"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            id="By-Personal"
                            name="employeeEmailType"
                            value="Personal"
                            checked={
                              state.employeeEmailType.value === "Personal"
                            }
                            onChange={handleChanges}
                          />
                          <label htmlFor="By-Personal">
                            {props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.option-Personal"
                            )}
                          </label>
                        </div>
                      </li>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-8">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.dropdown.text.Employee-Language"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <div className="Custom-select">
                        <DropdownComponent
                          name="prefferedLanguage"
                          id="prefferedLanguage"
                          options={decidePreferredLngDrp()}
                          isMultiSelect={false}
                          option_key="LanguageId"
                          option_display="Language"
                          onChange={(e) => {
                            if (state.prefferedLanguage.isEditable) {
                              onDropDownChange(e);
                            }
                          }}
                          values={state.prefferedLanguage.value}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          isSearchOption={true}
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          ref={state.prefferedLanguage.ref}
                        />
                        {state.prefferedLanguage?.error && (
                          <span className="error">
                            {state.prefferedLanguage.error}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "STD-Employer-Statement.form.subheading1.text"
                    )}
                  </span>
                </h2>
                <div className="row">
                  {/* <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.dropdown.text.Region"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <div className="Custom-select">
                        {props.region && (
                          <DropdownComponent
                            name="region"
                            id="region"
                            options={props.region}
                            isMultiSelect={false}
                            option_key="coRegionID_PK"
                            option_display="regionName"
                            onChange={onDropDownChange}
                            values={state.region.value}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            ref={state.region.ref}
                          />
                        )}
                        {state.region?.error && (
                          <span className="error">{state.region.error}</span>
                        )}
                      </div>
                    </div>
                  </div> */}

                  <div className="col-12 col-sm-12 col-md-12 col-lg-8">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.dropdown.text.Division/Location"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      {props.location && (
                        <DropdownComponent
                          name="location"
                          id="location"
                          options={props.location}
                          isMultiSelect={false}
                          option_key="coLocationID_PK"
                          option_display="regionLocationText"
                          // onChange={onDropDownChange}
                          onChange={(e) => {
                            if (state.location.isEditable) {
                              onDropDownChange(e);
                            }
                          }}
                          values={state.location.value}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          isSearchOption={true}
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          ref={state.location.ref}
                        />
                      )}
                      {state.location?.error && (
                        <span className="error">{state.location.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-10 col-sm-11 col-md-11 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Job"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <div className="">
                        <input
                          type="text"
                          className="form-control"
                          placeholder={props.context.t("Setting.Type.Here.text")}
                          name="jobTitle"
                          value={state.jobTitle.value}
                          ref={state.jobTitle.ref}
                          onChange={handleChanges}
                          readOnly={!state.jobTitle.isEditable}
                        />
                        {/* <DropdownComponent
                          name="jobTitle"
                          id="jobTitle"
                          options={props.job ? props.job : []}
                          isMultiSelect={false}
                          option_key="jobID_PK"
                          option_display="jobName"
                          onChange={onDropDownChange}
                          values={state.jobTitle.value}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          isSearchOption={true}
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          ref={state.jobTitle.ref}
                        /> */}
                        {state.jobTitle?.error && (
                          <span className="error">{state.jobTitle.error}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-1 col-sm-1 col-md-1 col-lg-1">
                    <div className="form-group margin-top-30">
                      <a onClick={onAddJob} className="btn">
                        <img src={add} />
                      </a>
                    </div>
                  </div> */}
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.dropdown.text.DepartmentID/CostCentre"
                        )}
                      </label>
                      <div className="form-group">
                        <input
                          readOnly={!state.departmentName.isEditable}
                          placeholder={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          )}
                          className="form-control"
                          name="departmentName"
                          value={state.departmentName.value}
                          ref={state.departmentName.ref}
                          onChange={handleChanges}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Plan-Type"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <div className="Custom-select">
                        {props.planLink && (
                          <DropdownComponent
                            name="planLink"
                            id="planLink"
                            options={props.planLink}
                            isMultiSelect={false}
                            option_key="payRollID_PK"
                            option_display="payRollName"
                            onChange={onDropDownChange}
                            values={state.planLink.value}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            ref={state.planLink.ref}
                          />
                        )}
                        {state.planLink?.error && (
                          <span className="error">{state.planLink.error}</span>
                        )}
                      </div>
                    </div>
                  </div> */}
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group Date-feild">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.calender.Date-Of-Hire"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                        {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                      </label>
                      <CustomDatePicker
                        readOnly={!state.dateOfHire.isEditable}
                        id="dateOfHire"
                        selected={state.dateOfHire.value}
                        onChange={(e) => {
                          if (state.dateOfHire.isEditable) {
                            onDateChange(e, "dateOfHire");
                          }
                          // onDateChange(e, "dateOfHire");
                        }}
                        maxDate={moment().toDate()}
                        placeholderText={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Calender.PlaceHolder.Common.SelectHere"
                        )}
                        ref={state.dateOfHire.ref}
                        className="form-control"
                      />
                      {state.dateOfHire?.error && (
                        <span className="error">{state.dateOfHire.error}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="">
                    {props.context.t(
                      "STD-Employer-Statement.form.Employee-Details.label.text.Employment-Status"
                    )}
                  </label>
                  <ul>
                    <li className="Radio-box height-150">
                      <div className="check-col">
                        <input
                          type="radio"
                          id="By-FullTime"
                          name="workDay"
                          value="FullTime"
                          checked={state.workDay.value === "FullTime"}
                          onChange={handleChanges}
                        />
                        <label htmlFor="By-FullTime">
                          {props.context.t(
                            "STD-Employer-Statement.form.Employement-Status.option-Full-Time"
                          )}
                        </label>
                      </div>
                      <div className="check-col">
                        <input
                          type="radio"
                          id="By-Contract"
                          name="workDay"
                          value="Contract"
                          checked={state.workDay.value === "Contract"}
                          onChange={handleChanges}
                        />
                        <label htmlFor="By-Contract">
                          {props.context.t(
                            "STD-Employer-Statement.form.Employement-Status.option-Contract"
                          )}
                        </label>
                      </div>
                      <div className="check-col">
                        <input
                          type="radio"
                          id="By-Casual"
                          name="workDay"
                          value="Casual"
                          checked={state.workDay.value === "Casual"}
                          onChange={handleChanges}
                        />
                        <label htmlFor="By-Casual">
                          {props.context.t(
                            "STD-Employer-Statement.form.Employement-Status.option-Casual"
                          )}
                        </label>
                      </div>
                      <div className="check-col">
                        <input
                          type="radio"
                          id="By-PartTime"
                          name="workDay"
                          value="PartTime"
                          checked={state.workDay.value === "PartTime"}
                          onChange={handleChanges}
                        />
                        <label htmlFor="By-PartTime">
                          {props.context.t(
                            "STD-Employer-Statement.form.Employement-Status.option-Part-Time"
                          )}
                        </label>
                      </div>
                      <div className="check-col">
                        <input
                          type="radio"
                          id="By-Other"
                          name="workDay"
                          value="Other"
                          checked={state.workDay.value === "Other"}
                          onChange={handleChanges}
                        />
                        <label htmlFor="By-Other">
                          {props.context.t(
                            "STD-Employer-Statement.form.Employement-Status.option-Other"
                          )}
                        </label>
                      </div>
                    </li>
                    {state.workDay.value === "Other" && (
                      <div className="form-group">
                        <input
                          placeholder={props.context.t(
                            "STD-Employer-Statement.form.dropdown.PlaceHolder.Common.IfOtherSpecifyHere"
                          )}
                          className="form-control"
                          name="otherEmploymentStatus"
                          value={state.otherEmploymentStatus.value}
                          onChange={handleChanges}
                        />
                      </div>
                    )}

                    <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                      <div className="form-group Date-feild">
                        <label htmlFor="">
                          {props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.label.calender.Contract-Expiry-Date"
                          )}
                          {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                        </label>
                        <CustomDatePicker
                          id="contractExpiryDate"
                          selected={state.contractExpiryDate.value}
                          onChange={(e) => {
                            onDateChange(e, "contractExpiryDate");
                          }}
                          placeholderText={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.Calender.PlaceHolder.Common.SelectHere"
                          )}
                          ref={state.contractExpiryDate.ref}
                          className="form-control"
                        />
                        {state.contractExpiryDate?.error && (
                          <span className="error">
                            {state.contractExpiryDate.error}
                          </span>
                        )}
                      </div>
                    </div>

                    <h2 className="Sub-Heading">
                      <span>
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Hours-of-Work"
                        )}
                      </span>
                    </h2>
                    {/* <div className="one-line"></div>
                    <hr />
                    <div className="one-line"></div> */}
                    <li className="Custom-check-box">
                      {state.weekWDH.value.length
                        ? state.weekWDH.value.map((day) => (
                          <div key={day.shift} className="check-col">
                            <label htmlFor="By-Last-Name">
                              {props.context.t("STD-Employer-Statement.form.Employee-Details.label.text." + day.shift)}
                            </label>
                            <div>
                              <div className="form-group">
                                <label htmlFor="">&nbsp;</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name={day.shift}
                                  value={day.hours}
                                  onChange={handleWeekShift}
                                  autoComplete="off"
                                />
                              </div>
                            </div>
                          </div>
                        ))
                        : null}
                    </li>
                  </ul>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Ques5"
                        )}
                      </label>
                      <ToggleComponent
                        name="enableWorkShift"
                        isActive={state.enableWorkShift.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                    <div>
                      {state.enableWorkShift.value === "Yes" ? (
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder={props.context.t(
                                "STD-Employer-Statement.form.dropdown.PlaceHolder.Common.IfOtherSpecifyShift"
                              )}
                              name="workShifts"
                              value={state.workShifts.value}
                              ref={state.workShifts.ref}
                              onChange={handleChanges}
                            />
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row">
                  {props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature ? <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Name-File-Contact"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <div className="Custom-select">
                        {props.supervisorList && (
                          <DropdownComponent
                            name="managerName"
                            id="managerName"
                            options={props.supervisorList}
                            isMultiSelect={false}
                            option_key="supervisorID_PK"
                            option_display="fullNameWithEmail"//"primaryName"
                            onChange={(e) => {
                              if (state.managerName.isEditable) {
                                onDropDownChange(e);
                              }
                            }}
                            values={state.managerName.value}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            ref={state.managerName.ref}
                          />
                        )}
                        {state.managerName?.error && (
                          <span className="error">
                            {state.managerName.error}
                          </span>
                        )}
                      </div>
                    </div>
                  </div> :
                    <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                      <div className="form-group">
                        <label htmlFor="">
                          {props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Name-File-Contact"
                          )}
                          <span size="5" className="error-star">
                            *
                        </span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={props.context.t("ACCOMODATION-Employee-Information.form.label.PlaceHolder.Common.TypeHere")}
                          // maxLength="14"
                          name="managerNameText"
                          value={state.managerNameText.value}
                          ref={state.managerNameText.ref}
                          onChange={handleChanges}
                          readOnly={!state.managerNameText.isEditable}
                        />
                        {state.managerNameText?.error && (
                          <span className="error">
                            {state.managerNameText.error}
                          </span>
                        )}
                      </div>
                    </div>
                  }
                  {/* <div className="col-1 col-sm-1 col-md-1 col-lg-1">
                    <div className="form-group margin-top-30">
                      <a onClick={onAddManager} className="btn">
                        <img src={add} />
                      </a>
                    </div>
                  </div> */}
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Phone"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={PHONE_PLACEHOLDER}
                        maxLength="14"
                        name="managerPhone"
                        value={state.managerPhone.value}
                        ref={state.managerPhone.ref}
                        onChange={handleChanges}
                        readOnly={!state.managerPhone.isEditable}
                      />
                      {state.managerPhone?.error && (
                        <span className="error">
                          {state.managerPhone.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Email"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={EMAIL_PLACEHOLDER}
                        name="managerEmail"
                        value={state.managerEmail.value}
                        ref={state.managerEmail.ref}
                        onChange={handleChanges}
                        readOnly={!state.managerEmail.isEditable}
                      />
                      {state.managerEmail?.error && (
                        <span className="error">
                          {state.managerEmail.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "STD-Employer-Statement.form.label.Manager-Language-Preference"
                        )}
                      </label>
                      <ul>
                        <li className="Radio-box">
                          <div className="check-col">
                            <input
                              type="radio"
                              id="By-Eng"
                              name="futureCommunication"
                              value={ENGLISH}
                              checked={
                                state.futureCommunication.value === ENGLISH
                              }
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-Eng">
                              {props.context.t(
                                "STD-Employer-Statement.form.label.Manager-Language.option-English"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              id="By-FRENCH"
                              name="futureCommunication"
                              value={FRENCH}
                              checked={
                                state.futureCommunication.value === FRENCH
                              }
                              onChange={handleChanges}
                            />
                            <label htmlFor="By-FRENCH">
                              {props.context.t(
                                "STD-Employer-Statement.form.label.Manager-Language.option-French"
                              )}
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    {/* <div className="panel-footer margn-50">
                      <a
                        tabIndex="0"
                        onClick={previousStep}
                        className="btn btn-primary"
                      >
                        {props.context.t(
                          "STD-Employer-Statement.form.button.previous"
                        )}
                      </a>
                    </div> */}
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="panel-footer text-right margn-50">
                      <a
                        tabIndex="0"
                        onClick={() => onSubmit(false, false)}
                        className="btn btn-blue"
                      >
                        {props.context.t(
                          "AIR-Employer-Information.form.button.save-for-later.title"
                        )}
                      </a>
                      <a
                        tabIndex="0"
                        onClick={onSubmit}
                        className="btn btn-primary margin-left-5"
                      >
                        {props.context.t(
                          "STD-Employer-Statement.form.button.save-and-move-next-step.title"
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployeeDetails;
